import { useId, useState } from 'react';
export default function RadioButtonList({ items, name, selected, label, defaultOptionLabel, onChange }) {

    const buttonListId = useId();
    const newItems = defaultOptionLabel != null ? items.toSpliced(0, 0, { name: defaultOptionLabel, value: -1 }) : items;

    const listItems = newItems.map(item =>
        <div key={item.name} className="checked-item">
            <input id={buttonListId + item.name} type="radio" name={name} value={item.value} defaultChecked={item.value == selected} onChange={() => { onChange && onChange(item.name) }} />
            <label htmlFor={buttonListId + item.name}>
                <span className="ml-1">{item.name}</span>
            </label>
        </div>
    );

    return (
        <fieldset>
            <legend className="legend">{label}</legend>
            {listItems}
        </fieldset>
    );
}